import { Badge } from "../../../../components/ui/badge";
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "../../../../components/ui/avatar";
import { Progress } from "../../../../components/ui/progress";
import Utility from "../../../../helper/utilityHelper";
import avatarImg from "../../../../assets/images/logo/avatarImg.jpg";

const ListItem = ({ item, index }) => {
  const { name, phone, totalCourtBookings, amount, color, image } = item;

  return (
    <div className="flex flex-col sm:flex-row flex-wrap gap-7 sm:gap-4 w-full p-2 px-4 hover:bg-default-50 rounded-lg">
      <div className="flex-none flex flex-wrap items-center gap-3">
        <div className="relative inline-block">
          <Avatar>
            <AvatarImage
              src={image ? Utility.getImagePath(image) : avatarImg}
              alt={name || "Customer"}
              className="object-cover"
            />
            <AvatarFallback className="bg-primary/20 text-primary font-semibold">
              {name ? name.charAt(0).toUpperCase() : "U"}
            </AvatarFallback>
          </Avatar>
          <Badge className="w-[18px] h-[18px] bg-warning/90 text-[10px] font-semibold p-0 items-center justify-center absolute left-[calc(100%-14px)] top-[calc(100%-16px)] bg-yellow-400">
            {index}
          </Badge>
        </div>
        <div>
          <div className="text-sm font-medium text-default-800 mb-1 whitespace-nowrap">
            {name}
          </div>
          {/* {phone && (
            <div className="text-xs text-default-600 whitespace-nowrap">
              {phone}
            </div>
          )} */}
        </div>
      </div>

      <div className="flex-1"></div>

      <div className="flex-none">
        <Badge variant="soft">PKR {amount}</Badge>
      </div>

    </div>
  );
};

export default ListItem;
